import {
  ChangeEvent,
  FunctionComponent,
  MutableRefObject,
  RefObject,
  useRef,
  useState,
} from "react";
import Button from "../Button/Button";
import Resizer from "react-image-file-resizer";

export interface FileUploadType {
  id: string;
  label: string;
  name: string;
  showLabel?: boolean;
  setFile: Function;
  error?: boolean;
  errorText?: String;
}
const acceptedTypes = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/jpg",
];

const FileUploadField: FunctionComponent<FileUploadType> = ({
  id,
  label,
  name,
  showLabel,
  error,
  errorText,
  setFile,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>();
  const [inputError, setInputError] = useState("");
  const input = useRef<any>();
  const resizeFile = (file: File) =>
    new Promise<any>((resolve) => {
      Resizer.imageFileResizer(
        file,
        980,
        980,
        "JPEG",
        90,
        0,
        (uri) => {
          resolve(uri);
        },
        "blob"
      );
    });
  const handleFileInputChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    setInputError("");
    if (file) {
      if (!acceptedTypes.includes(file.type)) {
        setSelectedFile(null);
        setInputError(
          "Wir unterstützen nur folgende Formate: .pdf, .jpg, .jped, .png"
        );
      } else {
        setSelectedFile(file);
        if (file.type === "application/pdf") {
          const reader = new FileReader();
          reader.readAsArrayBuffer(file);
          reader.onloadend = () => {
            if (reader.result && typeof reader.result !== "string") {
              const buffer = Buffer.from(new Uint8Array(reader.result));
              setFile(JSON.stringify({ buffer, type: file.type }), id);
            }
          };
        } else {
          const blob = await resizeFile(file);
          const arrayBuffer = await blob.arrayBuffer();
          const buffer = Buffer.from(new Uint8Array(arrayBuffer));
          setFile(JSON.stringify({ buffer, type: file.type }), id);
        }
      }
    } else {
      setSelectedFile(null);
    }
  };
  const handleButtonClicked = () => {
    if (input && input.current) {
      input.current.click();
    } else {
      setInputError("Es gab einen Fehler bei der Auswahl");
    }
  };

  return (
    <div>
      <div className={`text-sm mb-2 ${!label || !showLabel ? "hidden" : null}`}>
        <label
          id={[name, "label"].join("-")}
          htmlFor={[name, "input"].join("-")}
        >
          {label}
        </label>
      </div>
      <div className="flex items-center">
        <Button
          variant="outline"
          size="small"
          className="mr-2"
          onPress={() => handleButtonClicked()}
        >
          Datei auswählen
        </Button>
        {inputError && <p className="text-red-700">{inputError}</p>}
        {!inputError && (
          <p>{selectedFile ? selectedFile.name : "Nichts ausgewählt"}</p>
        )}
      </div>
      <input
        className="hidden"
        type="file"
        name={label}
        onChange={handleFileInputChange}
        accept={acceptedTypes.join(",")}
        ref={input}
      />
      {error ? <p className="mt-1 text-xs text-red-500">{errorText}</p> : null}
    </div>
  );
};

export default FileUploadField;
